﻿$(document).ready(function () {
    //guid
    /*$('.password-default').val(function () {
        (Math.floor((1 + Math.random()) * 0x10000)).toString(16).substring(1);
    });*/

    // CHANGE PASSWORD validation
    $('#btnChangePass').click(function () {
        var submitBtn = $('#btnChangePass');
        var formChangePass = $('#frmChangePass');
        var currentPass = formChangePass.find('#currentPass');
        var newPass = formChangePass.find('#newPass');
        var confirmPass = formChangePass.find('#confirmPass');

        if (matchVal(newPass, confirmPass) === false) {
            $('#confirmPass-error').show();
            $('#confirmPass-error').parent().show();            
        }
        // loop through inputs and run check functions
        formChangePass.find('input[type=password]').each(function () {
            var valCount = $(this).val().length;
            if (minLengthCheck(5, valCount) === false) {
                $('#newPass-error').show();
                $('#newPass-error').parent().show();
            }
        });
    });

    // check param is of min length
    function minLengthCheck(minVal, val) {
        if (val < minVal) {
            return false;
        } else {
            return true;
        }
    }

    // check two params match value
    function matchVal(val1, val2) {
        if (val1.val() !== val2.val()) {
            return false;
        } else {
            return true;
        }
    }


    // REGISTER NEW USER validation

    // remove novalidate set by jquery
    $("#new-user-form").validate();
    $("#new-user-form").removeAttr("novalidate");
    var newUserSubmissioncount = 0;

    // validation against required fields, emails with dot separators.
    $('#btnNewUser').click(function () {
        var submitBtn = $('#btnNewUser');
        var formNewUser = $('#frmNewUser');
        var firstName = $('#firstName');
        var lastName = $('#lastName');
        var email = $('#email');
        var pass = $('#pass');
        var passConfirm = $('#passConfirm');

        // prepend Title message of error summary only once!
        if (newUserSubmissioncount === 0) {
            var validationSummary = $('#validation-summary-errors').prepend("<strong>Please correct the following errors in your submission:</strong>");
            newUserSubmissioncount++;
        } else {
            validationSummary = $('#validation-summary-errors');
        }
        // ensures password and confirm both match
        if (matchVal(pass, passConfirm) === false) {
            $('#confirmPass-error').show();
            $('#confirmPass-error').parent().fadeIn();
            validationSummary.css("position", "fixed").fadeIn();            
        }
        // empty fields check
        formNewUser.find(':input:not(:checkbox):not(:button)').each(function () {
            if ($(this).val().length === 0) {
                $(this).next().css({ "display": "block" }).fadeIn();
                validationSummary.css("position","fixed").fadeIn();
            }
        });

    });

});